import { render } from "./Shortcuts.vue?vue&type=template&id=704a3430&scoped=true"
import script from "./Shortcuts.vue?vue&type=script&lang=js"
export * from "./Shortcuts.vue?vue&type=script&lang=js"

import "./Shortcuts.vue?vue&type=style&index=0&id=704a3430&scoped=true&lang=css"

import exportComponent from "/root/www/logbuch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704a3430"]])

export default __exports__